/* import __COLOCATED_TEMPLATE__ from './sq-lazy-list.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _class2, _descriptor, _descriptor2, _class3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attribute, classNames } from '@ember-decorators/component';
import { reads } from '@ember/object/computed';
/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import { scheduleOnce, throttle } from '@ember/runloop';
import { htmlSafe } from '@ember/template';
import EmberObject, { computed } from '@ember/object';
import { observes } from '@ember-decorators/object';
import Component from '@ember/component';
import $ from 'jquery';

/*
  What's up? I'm SqLazyListComponent.

  I fit my height to my parent container and then act like an {{#each}} except
  I only render the items that are visible on screen. Use me when each row in
  your list or table is expensive to render, and you're OK not putting
  everything in the DOM. To be clear: I break printing and Cmd-F for finding
  things, so the pay-off has to be worth it.

  I add hooks to window.resize and listen for scroll events on myself. I figure
  out the total height of all my content based on the rowHeight you give me and
  the number of items you pass in. If the number of items is really, really high
  then my "virtual" scroll element will be too big for some browsers. I should
  be just fine with tens of thousands of things though.

  My markup looks like this:

  {{#sq-lazy-list yourArrayHere
                  rowHeight=60
                  lastItemBecameVisible=(action "scrollToBottom")
                  as |arrayItem|}}
    {{your-component-here item=arrayItem action="whatever"}}
  {{/sq-lazy-list}}

  The 'lastItemBecameVisible' action is optional. The rowHeight should match the
  CSS for your items so that the correct number of rows are displayed.

  When yourArrayHere is [ 'hi', 'bye', 'yo' ] I produce this DOM
  (without comments):

  <!-- I am the component's element: -->
  <div class="sq-lazy-list__container">
    <!-- I am a virtual element that may be very very tall: -->
    <div class="sq-lazy-list__scroller" style="height: 180px; padding: 0px 0px 0px 0px;">
      <!-- like #each but only for visible elements: -->
      <div class="your-component" style="transform: translateY(60px)">hi</div>
      <div class="your-component" style="transform: translateY(60px)">bye</div>
      <div class="your-component" style="transform: translateY(60px)">yo</div>
    </div>
  </div>

  In addition I support the following slightly hacky features:
   - if you set `hasHeader=true` then I yield you a "row" with `isHeader` and
     the markup you use for that row is put inside a fixed position header with
     class .sq-lazy-list__header
   - if you set `hasFooter=true` then I yield you a "row" with `isFooter` and
     the markup you use for that row is put inside a fixed position footer with
     class .sq-lazy-list__footer
   - if you render some content with a class `sq-lazy-list__fixed-x` then I will
     keep that content visible on the left side even when your content needs to
     scroll horizontally

  TODO:
    - something better than fitting to the container height after measuring?
    - event tracking (probably just trigger more actions on scroll?)
    - mobile support (so far untested)
    - webkit-scroll stuff
    - tidier action support - yield second "row action" argument with each row?
*/
let SqLazyList = (_dec = classNames('sq-lazy-list__container'), _dec2 = reads('rowHeight'), _dec3 = computed('items.[]', 'startIndex', 'endIndex', 'rowHeight'), _dec4 = computed('scrollTop', 'rowHeight'), _dec5 = computed('scrollTop', 'containerHeight', 'rowHeight'), _dec6 = computed('startOffset'), _dec7 = computed('endOffset'), _dec8 = computed('hasHeader', 'headerRowHeight'), _dec9 = computed('hasFooter', 'rowHeight'), _dec10 = computed('items.length', 'rowHeight'), _dec11 = computed('scrollHeight', 'headerHeight', 'footerHeight'), _dec12 = computed('scrollHeight', 'headerHeight', 'footerHeight'), _dec13 = computed('element', 'maxContentHeight'), _dec14 = observes('items.[]'), _dec(_class = (_class2 = (_class3 = class SqLazyList extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "rowHeight", 40);
    _defineProperty(this, "scrollTop", 0);
    _defineProperty(this, "containerHeight", 0);
    _defineProperty(this, "hasHeader", false);
    _defineProperty(this, "hasFooter", false);
    _defineProperty(this, "hideFooterTopBorder", false);
    _defineProperty(this, "footerRowStyle", '');
    _initializerDefineProperty(this, "style", _descriptor, this);
    _defineProperty(this, "minRowsToShow", 1);
    // arbitrary min number of rows to show
    // Defaults to rowHeight, but can be overridden
    _initializerDefineProperty(this, "headerRowHeight", _descriptor2, this);
    // signify which content to render inside the block
    _defineProperty(this, "headerRow", EmberObject.create({
      isHeader: true
    }));
    _defineProperty(this, "footerRow", EmberObject.create({
      isFooter: true
    }));
  }
  get visibleRows() {
    const startIndex = this.startIndex;
    const endIndex = this.endIndex;
    const rowHeight = this.rowHeight;
    return this.items.slice(startIndex, endIndex).map((item, i) => {
      const identifier = item.id ?? i;
      const rowKeyId = String(identifier) + String(startIndex);
      const rowKey = `row-${rowKeyId}`;
      // transform each element the same amount. they get pushed down from
      // where they would otherwise be (sort of like position: relative)
      const offset = rowHeight * startIndex;

      // adding -webkit-transform because karma chrome wasn't picking up on the normal transform on kochiku
      const rowStyle = htmlSafe(`transform: translateY(${offset}px); -webkit-transform: translateY(${offset}px);`);
      return {
        rowKey,
        item,
        rowStyle
      };
    });
  }
  get startOffset() {
    return this.scrollTop / this.rowHeight;
  }
  get endOffset() {
    return (this.scrollTop + (this.containerHeight ?? 0)) / this.rowHeight;
  }
  get startIndex() {
    return Math.max(0, Math.floor(this.startOffset));
  }
  get endIndex() {
    return Math.ceil(this.endOffset);
  }
  get headerHeight() {
    return this.hasHeader ? this.headerRowHeight : 0;
  }
  get footerHeight() {
    return this.hasFooter ? this.rowHeight : 0;
  }
  get scrollHeight() {
    return this.items.length * this.rowHeight;
  }
  get maxContentHeight() {
    return this.scrollHeight + this.headerHeight + this.footerHeight;
  }
  get scrollerStyle() {
    return htmlSafe(`
      height: ${this.scrollHeight}px;
      margin-top: ${this.headerHeight}px;
      margin-bottom: ${this.footerHeight}px;
    `);
  }
  get canScroll() {
    const maxContentHeight = this.maxContentHeight;
    const scrollTopMaxHeight = Math.max(0, maxContentHeight - $(this.element).prop('clientHeight')); // eslint-disable-line ember/no-jquery
    const scrollLeftMaxWidth = $(this.element).prop('scrollWidth') - $(this.element).prop('clientWidth'); // eslint-disable-line ember/no-jquery
    const scrollTop = $(this.element).scrollTop(); // eslint-disable-line ember/no-jquery
    const scrollLeft = $(this.element).scrollLeft(); // eslint-disable-line ember/no-jquery
    return scrollTop > 0 && scrollTop < scrollTopMaxHeight || scrollLeft > 0 && scrollLeft < scrollLeftMaxWidth;
  }
  didInsertElement() {
    super.didInsertElement();
    const elementId = this.elementId;
    $(this.element).on(`scroll.${elementId}`, () => this.updatePositions([0, 0])); // eslint-disable-line ember/no-jquery
    $(this.element).on(`wheel.${elementId} mousewheel.${elementId}`, this.mouseWheelDidMove.bind(this)); // eslint-disable-line ember/no-jquery
    $(window).on(`resize.${elementId}`, this.windowDidResize.bind(this)); // eslint-disable-line ember/no-jquery
    scheduleOnce('afterRender', this, 'windowDidResize');
  }

  // intercept and manually scroll to fix a jiggling UI header bug on retina & ipad
  mouseWheelDidMove(event) {
    const scrollTopDidChange = this.updatePositions([event.originalEvent.deltaX, event.originalEvent.deltaY]);
    return !scrollTopDidChange;
  }
  touchStart(event) {
    // if the lazy list is the same height (or bigger) than its content,
    // then don't catch this event and let the page scroll instead:
    if (this.canScroll) {
      const elementId = this.elementId;
      $(window).on(`touchmove.${elementId}`, this.windowTouchMove.bind(this)); // eslint-disable-line ember/no-jquery
      $(window).on(`touchend.${elementId}`, this.windowTouchEnd.bind(this)); // eslint-disable-line ember/no-jquery
      this._touchStart = [event.originalEvent.targetTouches[0].pageX, event.originalEvent.targetTouches[0].pageY];
    }
    return undefined;
  }
  windowTouchMove(event) {
    const delta = [this._touchStart[0] - event.originalEvent.targetTouches[0].pageX, this._touchStart[1] - event.originalEvent.targetTouches[0].pageY];
    const scrollTopDidChange = this.updatePositions(delta);
    this._touchStart = [event.originalEvent.targetTouches[0].pageX, event.originalEvent.targetTouches[0].pageY];
    return !scrollTopDidChange;
  }
  windowTouchEnd() {
    const elementId = this.elementId;
    $(window).off(`touchmove.${elementId}`); // eslint-disable-line ember/no-jquery
    $(window).off(`touchend.${elementId}`); // eslint-disable-line ember/no-jquery
    this._touchStart = null;
  }
  willDestroyElement() {
    super.willDestroyElement();
    const elementId = this.elementId;
    $(this.element).off(`scroll.${elementId} wheel.${elementId} mousewheel.${elementId}`); // eslint-disable-line ember/no-jquery
    $(window).off(`resize.${elementId}`); // eslint-disable-line ember/no-jquery
  }
  windowDidResize() {
    throttle(this, 'updateHeight', 16, false);
  }
  updateHeight() {
    if (this.isDestroyed || this.isDestroying) {
      return;
    }
    // update min/max height before setting any other height based properties
    this.updateMinMaxHeight();
    this.set('containerHeight', $(this.element).height()); // eslint-disable-line ember/no-jquery
    this.updatePositions([0, 0]);
  }

  // note(seung): We need to update max height, so when there is a horizontal scrollbar
  // and the table doesn't stretch to the bottom of the viewport, we get a correctly positioned scrollbar.
  // We need min height because without it, when the screen is too small, the table tries to fit
  // everything in a sliver of space and it looks janky because headers and footers are overlapping.
  updateMinMaxHeight() {
    const scrollbarHeight = $(this.element).height() - $(this.element).prop('clientHeight'); // eslint-disable-line ember/no-jquery

    const minRows = Math.min(this.minRowsToShow, this.items.length);
    const minHeight = minRows * this.rowHeight + this.headerHeight + this.footerHeight + scrollbarHeight;
    const maxHeight = scrollbarHeight + this.maxContentHeight;
    // eslint-disable-next-line ember/no-jquery
    $(this.element).css({
      'max-height': `${maxHeight}px`,
      'min-height': `${minHeight}px`
    });
  }

  // allow parent components to load more for infinite scrolling, etc.
  notifyEndIndex() {
    const endIndex = this.endIndex - (this.hasHeader ? 1 : 0) - (this.hasFooter ? 1 : 0);

    // NOTE: we do an === instead of a >= in order to account
    // for any extra element that's below the visible area
    if (endIndex === this.items.length) {
      if (this._lastNotifiedEndIndex !== endIndex) {
        this.lastItemBecameVisible?.();
        this._lastNotifiedEndIndex = endIndex;
      }
    } else if (endIndex < this._lastNotifiedEndIndex) {
      // if we scroll back up, forget that we have already notified it
      this._lastNotifiedEndIndex = null;
    }
  }

  // FIXME (b) : don't use observers
  // eslint-disable-next-line ember/no-observers
  itemsDidChange() {
    scheduleOnce('afterRender', this, this.updateHeight);
  }

  // returns boolean of whether scroll top changed
  updatePositions([deltaX = 0, deltaY = 0]) {
    // TODO(carden): this fixed a flaky test - run.cancel on throttled calls?
    if (this.isDestroyed || this.isDestroying) {
      return false;
    }
    const scrollHeight = this.scrollHeight;
    const hasHeader = this.hasHeader;
    const hasFooter = this.hasFooter;
    const headerHeight = this.headerHeight;
    const footerHeight = this.footerHeight;
    const maxContentHeight = this.maxContentHeight;
    const scrollTopMaxHeight = Math.max(0, maxContentHeight - $(this.element).prop('clientHeight')); // eslint-disable-line ember/no-jquery
    let scrollTop = Math.max(0, $(this.element).scrollTop() + deltaY); // eslint-disable-line ember/no-jquery
    scrollTop = Math.min(scrollTop, scrollTopMaxHeight);

    // When we're close to the bottom of the list and scrollTop is a decimal value, it can cause endIndex to hide the last row.
    // Round up scrollTop if we're within the last row.
    if (Math.abs(scrollTopMaxHeight - scrollTop) <= this.rowHeight) {
      scrollTop = Math.ceil(scrollTop);
    }
    let scrollLeft = Math.max(0, $(this.element).scrollLeft() + deltaX); // eslint-disable-line ember/no-jquery
    scrollLeft = Math.min(scrollLeft, $(this.element).prop('scrollWidth') - $(this.element).prop('clientWidth')); // eslint-disable-line ember/no-jquery
    const scrollTopDidChange = this.scrollTop !== scrollTop;

    // this will invalidate the visibleRows and render any new ones
    this.set('scrollTop', scrollTop);
    this.notifyEndIndex();
    if (hasHeader) {
      // eslint-disable-next-line ember/no-jquery
      $(this.element).find('.sq-lazy-list__header').css({
        transform: `translateY(${scrollTop}px)`,
        height: headerHeight
      });
    }
    if (hasFooter) {
      // note(seung): this extra border helps the footer stop wiggling when reaching the bottom
      // The footer gets an additional border
      const footerBorder = 1;
      const footerTop = Math.min(scrollHeight, scrollTop + $(this.element).prop('clientHeight') - headerHeight - footerHeight - footerBorder // eslint-disable-line ember/no-jquery
      );
      const footer = $(this.element).find('.sq-lazy-list__footer'); // eslint-disable-line ember/no-jquery

      footer.attr('style', `transform: translateY(${footerTop}px); ${this.footerRowStyle}`);
      const isAtScrollBottom = footerTop === scrollHeight;
      footer.toggleClass('sq-lazy-list__footer--at-bottom', isAtScrollBottom);
    }
    // TODO: verify this works with multiple fixed columns
    // eslint-disable-next-line ember/no-jquery
    $(this.element).find('.sq-lazy-list__fixed-x').css({
      transform: `translateX(${scrollLeft}px)`
    });
    $(this.element).scrollTop(scrollTop); // eslint-disable-line ember/no-jquery
    $(this.element).scrollLeft(scrollLeft); // eslint-disable-line ember/no-jquery

    return scrollTopDidChange;
  }
}, _defineProperty(_class3, "positionalParams", ['items']), _class3), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "style", [attribute], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "headerRowHeight", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "visibleRows", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "visibleRows"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "startOffset", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "startOffset"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "endOffset", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "endOffset"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "startIndex", [_dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "startIndex"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "endIndex", [_dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "endIndex"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "headerHeight", [_dec8], Object.getOwnPropertyDescriptor(_class2.prototype, "headerHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "footerHeight", [_dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "footerHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "scrollHeight", [_dec10], Object.getOwnPropertyDescriptor(_class2.prototype, "scrollHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "maxContentHeight", [_dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "maxContentHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "scrollerStyle", [_dec12], Object.getOwnPropertyDescriptor(_class2.prototype, "scrollerStyle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canScroll", [_dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "canScroll"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "itemsDidChange", [_dec14], Object.getOwnPropertyDescriptor(_class2.prototype, "itemsDidChange"), _class2.prototype), _class2)) || _class);
export { SqLazyList as default };